import {Component, input, InputSignal, output, OutputEmitterRef} from '@angular/core';
import {LucideAngularModule, PlusCircle, Trash2} from '@shared/components/icons/google-icons';

@Component({
  selector: 'app-content-header',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './content-header.html'
})
export class ContentHeader {
  title: InputSignal<string> = input('');
  actionLabel: InputSignal<string> = input('');

  action: OutputEmitterRef<string> = output();

  executeAction() {
    this.action.emit("action");
  }

  protected readonly Trash2 = Trash2;
  protected readonly PlusCircle = PlusCircle;
}
